import React from "react";
import "react-table/react-table.css";
import GenericReactTable from "../../../../../utils/genericComponents/GenericReactTable";


const PreviewTab = ({ tableColumnsHeaders, previewdata }) => {
  // const [loading, setLoading] = useState(false);
  // const { getToken, token, error } = useContext(AuthContext);
  // const { instance } = useMsal();
  // const params = useParams();

  // const account = instance.getActiveAccount();
  // const request = {
  //   scopes: protectedResources.graphMe.scopes,
  //   account: account,
  // };





  // const emptyCheck = (tablecolumns) => tableColumnsHeaders.length > 0;
  return (
    <div>

      {/* {loading ? (
        <Spinner />
      ) : !emptyCheck(tableColumnsHeaders) ? (
        <div className="no-record-found-preview">Something went wrong..</div>
      ) : ( */}
      <GenericReactTable
        data={previewdata}
        columns={tableColumnsHeaders}
        tablewidth="100%"
        sortable={true}
        pagination={false}
        pagesize={10}
        size="sm"
      />
      {/* )} */}
    </div>
  );
};

export default PreviewTab;
